export default "__VITE_ASSET__699b8f8a__"